import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { utils } from '../../utils';
import { CustomFieldModel } from '../../types/customField';
import { EndpointResponse } from '../../types/endpoints';
import type { WriteRequestOptions } from '../requestOptions';

type RequestParams = {
  model: CustomFieldModel;
  id: number;
};

type Response = { success: boolean };

const validate = (model: CustomFieldModel, id: number) => {
  if (!model) {
    throw new Error('`model` is required');
  }
  if (!id) {
    throw new Error('`id` is required');
  }
};

export const deleteCustomField = async (
  scope: RequestScope,
  { model, id }: RequestParams,
  options: WriteRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(model, id);

    const result = await scopedApi(scope).delete<EndpointResponse<Response>>(`${model}/fields/${id}`, options);
    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
